import {CFInputCSS} from 'module/CustomField/style/cssCFInput'
import {css} from '@emotion/react'
import {zIndexDropDown} from 'module/Theme/BaseMuiTheme'
import {ITEM_SIZE} from 'module/Slct/util/SlctConstant'

export const cssSlctWrapper = css`
	min-height: ${CFInputCSS.height};
	height: 100%;
	width: 100%;
	box-sizing: border-box;
	display: grid;
	grid-template-columns: 1fr auto auto;
	align-items: center;
	border-radius: ${CFInputCSS.borderRadius};
	min-width: 90px;
	overflow: hidden;
`
export const cssSlctMultiWrapper = css`
	min-height: 60px;
	grid-template-rows: 1fr 1fr 1.7em;
`
export const cssSlctChildBase = css`
	border-radius: ${CFInputCSS.borderRadius};
	background: none;
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	min-width: 0; // Verhindert, dass das Kind die Parent-Breite beeinflusst
`
export const cssSlctSingleChild = css`
	grid-area: 1 / 1 / -1 / span 1;
`
export const cssSlctMultiChild1 = css`
	grid-area: 1 / 1 / span 2 / span 1;
`
export const cssSlctMultiChild2 = css`
	grid-area: 3 / 1 / span 1 / span 1;
`
export const cssSlctInput = css`
	outline: none;
	border: none;
	padding: 0 4px;
	min-width: 40px;
`
export const cssSlctPlaceholder = css`
	display: flex;
	align-items: center;
	padding: 0 4px;
	user-select: none;
	pointer-events: none; // fixes: safari click on input not recognized when value is set and placeholder under input element
`
export const cssSlctDisplayValue = css`
	width: 100%;
`
export const cssSlctPlaceholderMulti = css`
	padding: 2px 4px;
	user-input: none;
	overflow-x: hidden;
	overflow-y: auto;
	user-select: none;
`
export const cssSlctDisplayValueMultiRoot = css`
	border-radius: 10px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 3px;
	width: 100%;

	cursor: default;
	user-select: none;
	transition-duration: 0.2s;
	-o-transition-timing-function: ease-out;
	transition-property: margin-left;

	&.SlctDragOver {
		margin-left: 32px;
		cursor: move !important;
	}
`
export const cssSlctDisplayValueMultiText = css`
	padding: 1px 5px 1px 7px;;
	font-size: 0.85em;
`
export const cssRemoveDisplayValueMultiButton = css`
	border-radius: 1em;
	font-size: 1em;
	height: 1em;
	width: 1em;

	&:hover {
		background: #e3391d
	}
`

export const cssSlctMultiButtonRegion = css`
	grid-area: 1 / 3 / -1 / span 1;
`
export const cssSlctInputLoadingWrapper = css`
	grid-area: 1 / 2 / -1 / span 1;
	height: 1em;
	width: 1em;
	padding: 2px;
`
export const cssSlctClearButton = css`
	grid-area: 1 / 3 / -1 / span 1;
	border-radius: 30px;
	height: 1em;
	width: 1em;
	font-size: 1em;
	color: #666666;
	margin: 0 3px;

	&:hover {
		color: #555555;
		background: rgba(0, 0, 0, .2);;
	}
`
export const cssSlctMultiDisabled = css`
	color: ${CFInputCSS.disabled.color};
	background: ${CFInputCSS.disabled.background};
`
export const cssSlctMultiEnabled = css`
	color: ${CFInputCSS.color};
	background: ${CFInputCSS.background};
`
export const cssSlctEllipsis = css`
	white-space: pre;
	overflow: hidden;
	text-overflow: ellipsis;
`
export const cssSlctPlaceholderText = css`
	width: 100%;
	font-size: inherit;
	color: #7c7c7c;
`
export const cssSlctMenu = css`
	background: #fff;
	box-sizing: border-box;
	border: 1px solid #bbb;
	position: fixed;
	overflow: hidden;
	border-radius: 6px;
	min-height: ${ITEM_SIZE}px;
	z-index: ${zIndexDropDown};
	box-shadow: 0 4px 10px grey;

	& ::-webkit-scrollbar {
		width: 10px;
		height: 10px;
	}

	& ::-webkit-scrollbar-track {
		border-radius: 8px;
		background-color: #f0f0f0;
		border: 1px solid #cacaca;
	}

	& ::-webkit-scrollbar-thumb {
		border-radius: 8px;
		background-color: #ababab;
		border: 1px solid #444444;
	}
`
export const cssSlctMenuLoadingWrapper = css`
	height: 100%;
	width: 100%;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: center;
	color: black;
`
export const cssSlctEmpty = css`
	display: flex;
	align-items: center;
	justify-content: center;
	color: #6f6f6f;
	font-size: small;
	height: 100%;
	width: 100%;
`

/** SlctOption */
export const cssSlctOptionRoot = css`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 6px;
	height: 100%;
	cursor: default;
	padding-left: 8px;
	padding-right: 8px;
`
export const cssSlctOption = css`
	height: 100%;
	width: 100%;
	display: flex;
	align-items: center;
`
export const cssSlctOptionActive = css`
	background: #2684FF;
	color: #ffffff;
`
export const cssSelectable = css`
	background: #deebff;
	color: #000000;

	&:active {
		background: #b2d4ff;
		color: #000000;
	}
`
export const cssSlctOptionMemo = css`
	height: 1em;
	width: 1em;
	justify-self: end;
`
export const cssSlctOptionDisabled = css`
	color: #999999;
	background: #fafafa;

	&:active {
		color: #999999;
		background: #fafafa;
	}
`